/**
 * Centralized application constants.
 *
 * Carrier codes and event lifecycle statuses are derived from backend JSON
 * via scripts/generate-frontend-constants.py (run during the build pipeline)
 * so there is a single authoritative source (backend/handlers/constants.json).
 * This file re-exports named constants for consuming modules to reference by
 * name rather than by string literal.
 */

import carriersConfig from './generated/carriers.json';
import eventStatuses from './generated/event-statuses.json';

// Maintenance event lifecycle states (match Athena `status` column values).
export const EVENT_STATUS_IN_WORK = eventStatuses.inWork;
export const EVENT_STATUS_COMPLETED = eventStatuses.completed;
export const EVENT_STATUS_OOS = eventStatuses.oos;

/** Ordered list of carrier entries — a single record per carrier with its
 * code and the env-var key the backend uses for its Bedrock Knowledge Base.
 */
export const CARRIERS: ReadonlyArray<{ code: string; kbEnvVar: string }> =
  carriersConfig.carriers;

// Named carrier-code constants — derived once from CARRIERS so any addition
// lands in the generated JSON rather than here.
function carrierByCode(code: string): string {
  const match = CARRIERS.find((c) => c.code === code);
  if (!match) {
    throw new Error(`Carrier ${code} missing from generated/carriers.json — rerun scripts/generate-frontend-constants.py`);
  }
  return match.code;
}

export const CARRIER_SCX = carrierByCode('SCX');
export const CARRIER_ABR = carrierByCode('ABR');
export const CARRIER_FQA = carrierByCode('FQA');
export const CARRIER_ATN = carrierByCode('ATN');
export const CARRIER_CSB = carrierByCode('CSB');
export const CARRIER_ABX = carrierByCode('ABX');
export const CARRIER_HAL = carrierByCode('HAL');
export const CARRIER_ASA = carrierByCode('ASA');
